import cn from 'classnames';
import React, { useRef, useState } from 'react';
import { useTableStore } from 'src/features/list/store';
import useOnClickOutside from 'use-onclickoutside';

export const CustomTextCell = ({
  task,
  data,
  fieldId,
  api,
}: {
  task: any;
  fieldId: string;
  data: string;
  api: any;
}): JSX.Element => {
  const [fieldData, setFieldData] = useState(typeof data === 'string' ? data : '');
  const [isFocused, setIsFocused] = useState(false);
  const { isReadOnly } = useTableStore();
  const myRef = useRef(null);

  const { onUpdateCustomFieldData } = useTableStore((s) => ({
    onUpdateCustomFieldData: s.onUpdateCustomFieldData,
  }));

  const handleTextFieldData = (e) => {
    if (e.key === 'Enter') {
      handleSubmit();
    }
  };

  const handleSubmit = () => {
    if (task.id) {
      onUpdateCustomFieldData(task, fieldId, fieldData);
    }
    setIsFocused(false);
    api.stopEditing();
  };

  return (
    <div className="flex rounded-sm items-center" ref={myRef}>
      <input
        disabled={isReadOnly}
        type="text"
        className={cn(
          'text-sm text-gray-999 font-regular placeholder-gray-500 h-36 w-full bg-transparent pl-15',
          {
            'bg-white': isFocused,
          }
        )}
        onChange={(e) => {
          setFieldData(e.target.value);
        }}
        onKeyPress={handleTextFieldData}
        onFocus={(e) => {
          setIsFocused(true);
        }}
        onBlur={(e) => {
          if (fieldData) {
            handleSubmit();
          } else {
            setIsFocused(false);
          }
        }}
        value={fieldData}
        placeholder="Enter text"
      />
    </div>
  );
};
